import {Question} from "../_api";
import {t} from "../_i18n";


export const validateClosedQuestion = (question: any) => {
    let error: any = false
    const answersFullFilled =  question.answers?.filter((singleAnswer:any) => singleAnswer.text.trim() !== "" && singleAnswer.grade !== null)?.length < 2
    const answersJustText =  question.answers?.filter((singleAnswer:any) => singleAnswer.text.trim() !== "")?.length < 2
    const answersJustGrade =  question.answers?.filter((singleAnswer:any) => singleAnswer.grade !== null)?.length < 2


    if(question.text.trim() === "")
        error = t("Por favor, completa la pregunta.")

    if(question.text.trim() !== "" && (answersFullFilled && answersJustText && answersJustGrade)) {
        error = t("Por favor, introduce como mínimo 2 repuestas.")
    }else if(question.text.trim() !== "" && answersJustText) {
        error = t("Alguna de las respuestas está incompleta. Por favor, revísala.")
    }else if(question.text.trim() !== "" && answersJustGrade)
        error = t("Alguna de las respuestas está incompleta. Por favor, revísala.")

    return error
}

export const validateText = (text: any) => {
    let error: any = false

    if (text && text.length < 100)
        error = t('Por favor, escribe 100 caracteres como mínimo.')

    if (text === undefined || text.length === 0 )
        error = t('Por favor, escribe la descripción del puesto.')

    return error
}

export const validateReq = (text: any) => {
    let error: any = false

    if (text === undefined || text.length === 0 )
        error = t('Por favor, escribe la descripción del puesto.')

    return error
}

export const validateAcademicProgramInput = (academycProgramArray: any) => {
    return !(academycProgramArray.length >= 1)
}

export const validateStringVacancies = (number: any) => {
    if (number === undefined || number === null || (number && typeof(number) === "string") && number.trim() === "" || number === "" || number <= 0) return true
    return false
}

export function showErrorClosed(meta:any) {
    return (meta.invalid && (meta.submitFailed));
}
